import type { ComfortBreakdown, WeatherSnapshot } from '../types';

const clamp = (value: number, min = 0, max = 100) => Math.min(max, Math.max(min, value));

export function temperatureScore(temp: number): number {
  if (temp >= 23 && temp <= 29) return 100;
  if (temp < 23) return clamp(100 - (23 - temp) * 8);
  return clamp(100 - (temp - 29) * 10);
}

export function humidityScore(humidity: number): number {
  if (humidity >= 45 && humidity <= 68) return 100;
  if (humidity < 45) return clamp(100 - (45 - humidity) * 2);
  return clamp(100 - (humidity - 68) * 2.4);
}

export function airScore(aqi: number): number {
  if (aqi <= 50) return 100;
  if (aqi <= 100) return clamp(100 - (aqi - 50) * 0.8);
  if (aqi <= 150) return clamp(60 - (aqi - 100) * 0.8);
  return clamp(20 - (aqi - 150) * 0.25);
}

export function getComfortLabel(score: number): string {
  if (score >= 85) return 'Sangat nyaman';
  if (score >= 70) return 'Nyaman';
  if (score >= 55) return 'Cukup nyaman';
  if (score >= 40) return 'Kurang nyaman';
  return 'Tidak nyaman';
}

export function calculateComfort(
  weather: WeatherSnapshot,
  greenScore = 72,
): ComfortBreakdown {
  const t = temperatureScore(weather.apparentTemperature);
  const h = humidityScore(weather.humidity);
  const air = airScore(weather.usAqi);
  const rain = clamp(100 - weather.precipitationProbability);
  const green = clamp(greenScore);
  const score = Math.round(t * 0.32 + h * 0.13 + air * 0.25 + rain * 0.1 + green * 0.2);

  return {
    score,
    label: getComfortLabel(score),
    temperatureScore: Math.round(t),
    humidityScore: Math.round(h),
    airScore: Math.round(air),
    rainScore: Math.round(rain),
    greenScore: Math.round(green),
  };
}
